import React from 'react';
import { useFormContext } from "react-hook-form";
import { translate } from "../../Services/translation";
import CustomerInformation from "./CustomerInformation";

const CustomerInformationValidator = ({
                                          data,
                                          showPayment,
                                          schema,
                                          onClick,
                                          isB2C,
                                          control
                                      }) => {


    const { getValues, setError, clearErrors } = useFormContext();

    const onPartialSubmit = async () => {
        try {
            clearErrors();
            const values = getValues();
            await schema.validate(values, { abortEarly: false });
            onClick();
        } catch (errors) {
            errors.inner.forEach(error => {
                const fieldPath = error.path;
                setError(fieldPath, { type: 'manual', message: error.message });
            });
        }
    };


    return (
        <div>
            <p className="checkout__section-title">{translate('checkout.form.contactandaddressinformation')}</p>
            <div className="card">
                <div className="card__body card__body--large">
                    <div className="checkout__form-container">
                        {

                            data.map((x, index) => {
                                return (
                                    <CustomerInformation
                                        control={control}
                                        onClick={x.onClick}
                                        key={index}
                                        data={x}
                                        showCompanyAddress={x.showCompanyAddress}
                                        showDeliveryAddresses={x.showDeliveryAddresses}
                                        hasSameAsBillingAddress={x.hasSameAsBillingAddress}
                                        editable={!showPayment}
                                        isB2C={isB2C}
                                    />);
                            })
                        }

                        <button className="checkout__form-group-button" onClick={onPartialSubmit}
                                type="button">{showPayment ? translate('checkout.forms.edit') : translate('checkout.forms.next')}</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CustomerInformationValidator;
